<template>
  <div>
    <BListFilter
      v-model="form"
      label="Поиск по названию"
      :skeleton="skeleton"
      dense
      @change="onChangeDebounced"
    />

    <v-row dense>
      <v-col cols="6">
        <BTextFieldAte
          :region.sync="form.region"
          :municipality.sync="form.municipality"
          :school.sync="form.school"
          :skeleton="skeleton"
          style="min-width: 320px;"
          placeholder="Выберите ATE"
          model="Roadmap"
          @change="onChangeDebounced"
          @click:clear="onClearAte"
        />
      </v-col>

      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.is_published"
          label="Опубликовано?"
          :options="publishedOptions"
          :skeleton="skeleton"
          item-text="label"
          item-value="value"
          $type="select"
          @change="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BTextFieldAte from '@/components/forms/BTextFieldAte.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'


const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  is_published: null,
  region: void 0,
  municipality: void 0,
  school: void 0,
})

const PUBLISHED_OPTIONS = [
  { label: 'Опубликовано', value: true },
  { label: 'Не опубликовано', value: false },
]

export default {
  name: 'RoadmapsFilters',
  components: {
    BListFilter,
    BTextFieldAte,
    BAutocompleteCommon,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    publishedOptions: PUBLISHED_OPTIONS,
  }),
  methods: {
    onClearAte() {
      this.form = {
        ...this.form,
        region: void 0,
        municipality: void 0,
        school: void 0,
      }

      this.onChangeDebounced()
    },
  },
}
</script>
